import { useEffect } from "react";

// The sidebar and phone tab bar re-tap Feed with state.feedReset set. Run
// onReset once, then replace the history entry without it so a reload or Back
// doesn't repeat the reset.
const useFeedReset = ({ location, navigate, onReset }) => {
  const feedReset = location.state?.feedReset;
  useEffect(() => {
    if (!feedReset) return;
    onReset();
    window.scrollTo({ top: 0 });
    navigate({ pathname: location.pathname, search: location.search }, { replace: true });
  }, [feedReset]);
};

export default useFeedReset;
